import React from 'react';
import DocumentListImproved from '../components/documents/DocumentListImproved';

const Documents = () => {
  return <DocumentListImproved />;
};

export default Documents;
